import React, { forwardRef } from 'react';

const callAll = (...handlers) => (event) => {
  for (const handler of handlers) {
    if (typeof handler === 'function') handler(event);
  }
};

const AppInput = forwardRef(function AppInput({
  stopPropagation = false,
  preventDragStart = false,
  onPointerDown,
  onMouseDown,
  onTouchStart,
  onClick,
  onDragStart,
  ...props
}, ref) {
  const stopIfNeeded = (event) => {
    if (stopPropagation) event.stopPropagation();
  };

  const preventDragIfNeeded = (event) => {
    if (preventDragStart) event.preventDefault();
  };

  return (
    <input
      ref={ref}
      onPointerDown={callAll(stopIfNeeded, onPointerDown)}
      onMouseDown={callAll(stopIfNeeded, onMouseDown)}
      onTouchStart={callAll(stopIfNeeded, onTouchStart)}
      onClick={callAll(stopIfNeeded, onClick)}
      onDragStart={callAll(preventDragIfNeeded, onDragStart)}
      {...props}
    />
  );
});

export default AppInput;
